// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "body.modal-open{overflow-y:hidden;width:100%}@media (min-width:992px){body.modal-open{padding-right:1rem}}body.modal-open .page-header{@inclide (min-width: 992px){right:16px}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
